import { SET_APPOINTMENT_ID } from 'actions';

export function setAppointmentId(appointmentId: string) {
  return { appointmentId, type: SET_APPOINTMENT_ID };
}
